import React, { useState, useEffect } from "react";
import Form from "./Childs/Form";
import FormCard from "../../Common/Childs/Structure/FormCard";
import Description from "../../Common/Childs/Structure/Description";
import Title from "../../Common/Childs/Structure/Title";
import { useGlobal } from "../../../context/GlobalContextProvider";
import { useWallet } from "../../../context/WalletContextProvider";

const mainPageAPI = {
  get: (account, campaignId) =>
    fetch(`/api/sponsor/${account}/campaign/mainpage/${campaignId}`).then((res) => {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    }),
  update: (account, campaignId, data) =>
    fetch(`/api/sponsor/${account}/campaign/mainpage/update/${campaignId}`, {
      method: "PUT",
      body: JSON.stringify(data),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    }),
};

const fileAPI = {
  getByName: (filename) =>
    fetch(`/api/file/name/${filename}`).then((res) => {
      if (res.status === 204 || !res.ok) return null;
      return res.json();
    }),
};

const INITIAL_FORM_STATE = {
  campaign_id: 0,
  ct_main_logo: "",
  ct_icon_1: "",
  ct_icon_2: "",
  ct_icon_3: "",
  ct_icon_4: "",
  ct_icon_5: "",
  ct_icon_6: "",
  ct_icon_nft: "",
  ct_icon_beneficiary: "",
  ct_graphic_nft: "",
  ct_social_link_1: "",
  ct_social_link_2: "",
  ct_social_link_3: "",
  ct_social_link_4: "",
  ct_check_main_page_updated: false,
};

const INITIAL_BUFFER_STATE = {
  ct_icon_1: "",
  ct_icon_2: "",
  ct_icon_3: "",
  ct_icon_4: "",
  ct_icon_5: "",
  ct_icon_6: "",
  ct_icon_nft: "",
  ct_icon_beneficiary: "",
  ct_graphic_nft: "",
};

const Index = () => {
  const { account } = useWallet();
  const { campaign, setSpinner } = useGlobal();
  const [formData, setFormData] = useState(INITIAL_FORM_STATE);
  const [imageBuffer, setImageBuffer] = useState(INITIAL_BUFFER_STATE);

  useEffect(() => {
    if (!account || !campaign) return;

    const getData = async () => {
      try {
        setSpinner(true);
        const response = await mainPageAPI.get(account, campaign.campaign_id);

        if (response) {
          const {
            ct_main_logo, ct_icon_1, ct_icon_2, ct_icon_3, ct_icon_4,
            ct_icon_5, ct_icon_6, ct_icon_nft, ct_icon_beneficiary,
            ct_graphic_nft, ct_social_link_1, ct_social_link_2,
            ct_social_link_3, ct_social_link_4, campaign_id,
          } = response;

          for (const icon in INITIAL_BUFFER_STATE) {
            if (response[icon] && response[icon].length > 0) {
              const data = await fileAPI.getByName(response[icon]);
              setImageBuffer((prev) => ({ ...prev, [icon]: data }));
            }
          }

          setFormData({
            ct_main_logo: ct_main_logo || "", ct_icon_1: ct_icon_1 || "",
            ct_icon_2: ct_icon_2 || "", ct_icon_3: ct_icon_3 || "",
            ct_icon_4: ct_icon_4 || "", ct_icon_5: ct_icon_5 || "",
            ct_icon_6: ct_icon_6 || "", ct_icon_nft: ct_icon_nft || "",
            ct_icon_beneficiary: ct_icon_beneficiary || "",
            ct_graphic_nft: ct_graphic_nft || "",
            ct_social_link_1: ct_social_link_1 || "",
            ct_social_link_2: ct_social_link_2 || "",
            ct_social_link_3: ct_social_link_3 || "",
            ct_social_link_4: ct_social_link_4 || "",
            campaign_id,
          });
        }
      } catch (error) {
        console.error("Error loading main page data:", error);
      } finally {
        setSpinner(false);
      }
    };

    getData();
  }, [account, campaign, setSpinner]);

  const handleSubmit = async (data) => {
    const {
      ct_main_logo, ct_icon_1, ct_icon_2, ct_icon_3, ct_icon_4,
      ct_icon_5, ct_icon_6, ct_icon_nft, ct_icon_beneficiary,
      ct_graphic_nft, ct_social_link_1, ct_social_link_2,
      ct_social_link_3, ct_social_link_4, ct_check_main_page_updated,
    } = data;

    try {
      setSpinner(true);
      await mainPageAPI.update(account, campaign.campaign_id, {
        ct_main_logo, ct_icon_1, ct_icon_2, ct_icon_3, ct_icon_4,
        ct_icon_5, ct_icon_6, ct_icon_nft, ct_icon_beneficiary,
        ct_graphic_nft, ct_social_link_1, ct_social_link_2,
        ct_social_link_3, ct_social_link_4, ct_check_main_page_updated,
      });
    } catch (error) {
      console.error("Error updating main page:", error);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <>
      <Title title="Main Page Settings" />
      <Description text="Design features of your Campaign's main website." />
      <FormCard>
        <Form
          formData={formData}
          handleSubmit={handleSubmit}
          imageBuffer={imageBuffer}
          setSpinner={setSpinner}
        />
      </FormCard>
    </>
  );
};

export default Index;
